import styles from "./notificationcard.module.css";
import { Edit, Eye, EyeOff, MoreVertical } from "react-feather";
import { Dropdown } from "react-bootstrap";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const NotificationCard = ({ item, setArchiveModalOpen, setPublishModalOpen, setSelectedItem }) => {
    const history = useHistory();
    const { user, isAuthenticated } = useAuth0();

    return (<>
        {/* <div className={`${styles.ProspectCard}`}>
            <div className={`${styles.ProspectCardUnder}`} style={{ cursor: 'pointer' }} onClick={() => { history.push('/notification/email-sms-notification/view/' + item?.id) }}>
                <div className={`${styles.ProspectCardHeadSection}`}>
                    <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => e.stopPropagation()}>
                        <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                            <MoreVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                            <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { history.push('/notification/email-sms-notification/view/' + item?.id) }}>
                                <Eye /> Preview
                            </Dropdown.Item>
                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && < Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { history.push('/notification/email-sms-notification/edit/' + item?.id) }}>
                                <Edit /> Edit
                            </Dropdown.Item>}
                            {item?.is_archived === 0 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setArchiveModalOpen(true); setSelectedItem(item); }}>
                                <EyeOff /> Unpublished
                            </Dropdown.Item>}
                            {item?.is_archived === 1 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setPublishModalOpen(true); setSelectedItem(item); }}>
                                <Eye /> Published
                            </Dropdown.Item>}
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className={`${styles.ProsIMGSec}`}>
                        {item?.type === 'SMS' ? <img src="/static/img/sms-notification.svg" alt="" /> : <img src="/static/img/email-template.svg" alt="" />}
                    </div>
                    <div className={`${styles.HeadConSec}`}>
                        <p className={`${styles.ProsUserName}`}>
                            <span className={`${styles.UserName}`}>{item?.category}</span>
                        </p>
                    </div>
                </div>
                <div className={`${styles.ProspectCardFootSec}`}>
                    <p className={`${styles.LeaseConDate}`}>{dayjs(item?.created_at).fromNow()}</p>
                    <span className={`${styles.PublishBadge}`}>{item?.is_archived === 0 ? "Published" : "Unpublished"}</span>
                </div>
            </div>
        </div > */}

        <div className={`${styles.ListingCard}`} style={{ cursor: 'pointer' }} onClick={() => { history.push('/notification/email-sms-notification/view/' + item?.id) }}>
            <div className={`${styles.ListingImg}`}>{item?.type === 'SMS' ? <img src="/static/img/sms-notification.svg" alt="" /> : <img src="/static/img/email-template.svg" alt="" />}</div>
            <div className={`${styles.ListingDesSec}`}>
                <div className={`${styles.TitleRow}`}>
                    <span className={`${styles.Title}`}>{item?.category}</span>
                </div>
                <p className={`${styles.ListingDesSmallSec}`}>{dayjs(item?.created_at).fromNow()}</p>
                {item?.is_archived === 0 && <span className={`${styles.StatusBadge} ${styles.Open}`}>Published</span>}
                {!item?.is_archived === 0 && <span className={`${styles.StatusBadge} ${styles.Archive}`}>Unpublished</span>}
            </div>
            <div className={`${styles.ActionRight}`}>                              
                <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => e.stopPropagation()}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { history.push('/notification/email-sms-notification/view/' + item?.id) }}>
                            <Eye /> Preview
                        </Dropdown.Item>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && < Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { history.push('/notification/email-sms-notification/edit/' + item?.id) }}>
                            <Edit /> Edit
                        </Dropdown.Item>}
                        {item?.is_archived === 0 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setArchiveModalOpen(true); setSelectedItem(item); }}>
                            <EyeOff /> Unpublished
                        </Dropdown.Item>}
                        {item?.is_archived === 1 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setPublishModalOpen(true); setSelectedItem(item); }}>
                            <Eye /> Published
                        </Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    </>)
}

export default NotificationCard;